"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSchemeRequest = void 0;
var GetSchemeRequest = /** @class */ (function () {
    function GetSchemeRequest() {
    }
    return GetSchemeRequest;
}());
exports.GetSchemeRequest = GetSchemeRequest;
;
//# sourceMappingURL=getScheme.request.js.map